// extracted by mini-css-extract-plugin
export var form = "email-signup-module--form--563f4";
export var formError = "email-signup-module--form-error--2aa6c";
export var inputBorder = "email-signup-module--input-border--4ef08";
export var removeTopMargin = "email-signup-module--remove-top-margin--0fda0";